class Marquee {
  constructor() {
    this.els = document.querySelectorAll('.marquee');
    this.init();
  }

  init() {
    this.els.forEach(el => {
      if (getComputedStyle(el).display === 'none') return;

      const speed = parseFloat(el.dataset.marqueeSpeed) || 50;
      const direction = el.dataset.marqueeDirection || 'left';
      const ignoreStop = el.dataset.marqueeIgnorestop === 'true'; // ★追加
      this.setup(el, { speed, direction, ignoreStop });
    });
  }

  setup(el, options) {
    const wrapper = el.querySelector('.marquee-wrapper');
    const content = wrapper.querySelector('.marquee-content');

    // 無限ループ用クローン
    const clone = content.cloneNode(true);
    wrapper.innerHTML = '';
    wrapper.appendChild(content);
    wrapper.appendChild(clone);

    wrapper.style.display = 'flex';
    wrapper.style.flexWrap = 'nowrap';
    wrapper.style.whiteSpace = 'nowrap';

    const unitWidth = content.scrollWidth;
    let translateX = options.direction === 'left' ? 0 : -unitWidth;
    let autoVelocity = options.direction === 'left' ? -options.speed : options.speed;
    let velocity = autoVelocity;
    let isDragging = false;
    let isHover = false;
    let lastX = 0;
    let movedDistance = 0;

    const update = () => {
      // ★ ignoreStop=true の場合は hover 無視
      if (!isDragging && (!isHover || options.ignoreStop)) {
        velocity += (autoVelocity - velocity) * 0.05;
      }

      // ★ ignoreStop=false（標準） の場合のみ hover で停止
      if (isHover && !options.ignoreStop) {
        velocity = 0;
      }

      translateX += velocity * (1 / 60);

      // 無限ループ
      if (velocity < 0 && translateX <= -unitWidth) translateX += unitWidth;
      if (velocity > 0 && translateX >= 0) translateX -= unitWidth;

      wrapper.style.transform = `translateX(${translateX}px)`;
      requestAnimationFrame(update);
    };
    update();

    // --------------------
    // マウスオーバー停止（ignoreStop=false の場合のみ有効）
    // --------------------
    wrapper.addEventListener('mouseenter', () => {
      if (!options.ignoreStop) isHover = true;
    });
    wrapper.addEventListener('mouseleave', () => {
      isHover = false;
    });

    // --------------------
    // タッチ操作・ドラッグ処理（そのまま）
    // --------------------
    if ('ontouchstart' in window) {
      wrapper.addEventListener('touchstart', e => {
        isDragging = true;
        lastX = e.touches[0].pageX;
        velocity = 0;
      });
      wrapper.addEventListener('touchmove', e => {
        const dx = e.touches[0].pageX - lastX;
        lastX = e.touches[0].pageX;
        velocity = dx * 15;
        autoVelocity = dx < 0 ? -Math.abs(options.speed) : Math.abs(options.speed);
        translateX += dx;
      });
      wrapper.addEventListener('touchend', () => {
        isDragging = false;
      });
    }

    wrapper.addEventListener('mousedown', e => {
      if (e.button !== 0) return;
      isDragging = true;
      lastX = e.pageX;
      movedDistance = 0;
      velocity = 0;
    });

    document.addEventListener('mousemove', e => {
      if (!isDragging) return;
      const dx = e.pageX - lastX;
      lastX = e.pageX;
      translateX += dx;
      movedDistance += Math.abs(dx);
      if (movedDistance > 1 && !el.classList.contains('is-mousedown')) {
        el.classList.add('is-mousedown');
      }
      if (dx !== 0)
        autoVelocity = dx < 0 ? -Math.abs(options.speed) : Math.abs(options.speed);
      wrapper.style.transform = `translateX(${translateX}px)`;
    });

    const endDrag = () => {
      if (!isDragging) return;
      isDragging = false;
      el.classList.remove('is-mousedown');
      velocity = autoVelocity;
    };

    document.addEventListener('mouseup', endDrag);
    document.addEventListener('mouseleave', endDrag);
  }
}

// 初期化
export function initMarquee() {
  new Marquee();
}
